import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : '/api');

// The dashboard is hosted on Cloudflare Pages and sends no framing headers,
// so it can be embedded directly. It reads its backend token from ?token=
// (then strips it from the URL), so we fetch the shared token from our server
// and pass it in instead of every user getting a paste prompt.
const DASHBOARD_ORIGIN = 'https://kspdata-dashboard.pages.dev/';
const buildUrl = (token) =>
  `${DASHBOARD_ORIGIN}?token=${encodeURIComponent(token)}#dashboard`;

const WercMetrics = () => {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const authToken = localStorage.getItem('token');
    fetch(`${API_URL}/werc-metrics/token`, {
      headers: { Authorization: authToken ? `Bearer ${authToken}` : '' },
      signal: controller.signal,
    })
      .then(async (res) => {
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.message || `Request failed: ${res.status}`);
        setSrc(buildUrl(body.token));
      })
      .catch((err) => {
        if (err.name !== 'AbortError') setError(err.message);
      });
    return () => controller.abort();
  }, []);

  return (
    <div className="flex flex-col h-full gap-2">
      <div className="flex justify-between items-center flex-shrink-0">
        <h2 className="text-lg font-semibold text-slate-200">KSP Insights</h2>
        {src && (
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-slate-200"
          >
            Open in new tab <ExternalLink className="w-4 h-4" />
          </a>
        )}
      </div>
      {error && (
        <div className="p-4 rounded-lg bg-red-900/40 border border-red-700 text-red-200 text-sm">
          Could not load KSP Insights: {error}
        </div>
      )}
      {!error && !src && (
        <div className="p-4 text-slate-400 text-sm">Loading…</div>
      )}
      {src && (
        <iframe
          src={src}
          title="KSP Insights"
          className="w-full flex-1 min-h-0 rounded-lg border-0 bg-white"
        />
      )}
    </div>
  );
};

export default WercMetrics;
